import { render, staticRenderFns } from "./AccountImageUploader.vue?vue&type=template&id=20bcc0ec"
import script from "./AccountImageUploader.vue?vue&type=script&lang=js"
export * from "./AccountImageUploader.vue?vue&type=script&lang=js"
import style0 from "./AccountImageUploader.vue?vue&type=style&index=0&id=20bcc0ec&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports